import { ref, computed, onMounted } from "vue";
import customProtocolCheck from "custom-protocol-check";
import { api } from "@/axios";

export function useAppInstallation(deepLinkPath: string) {
  const isAppInstalled = ref(false);

  const download = ({ os }: { os: string }) => {
    window.open(api(`download/latest?os=${os}`), "_self");
  };

  const appLink = computed(() => `imagen-app://${deepLinkPath}`);

  onMounted(() => {
    customProtocolCheck(
      appLink.value,
      () => {
        isAppInstalled.value = false;
      },
      () => {
        isAppInstalled.value = true;
      }
    );
  });

  return {
    isAppInstalled,
    download,
    appLink,
  };
}
